import { t } from "i18next";
import { Chip, Tooltip } from "@material-tailwind/react";
import { statusColors } from "../../../theme/statusPalette";

interface ReplenishmentPriorityBadgeProps {
  priority: EasyTech.ReplenishmentPriority;
  size?: "sm" | "md" | "lg";
  className?: string;
  iconOnly?: boolean;
}

export const getReplenishmentPriorityStyle = (priority?: string | null) => {
  switch (priority?.toUpperCase()) {
    case "URGENT":
      return {
        soft: statusColors.red[100],
        mid: statusColors.red[400],
        solid: statusColors.red[500],
        text: statusColors.red[800],
      };
    case "NORMAL":
    default:
      return {
        soft: statusColors["chrono-gray"][100],
        mid: statusColors["chrono-gray"][400],
        solid: statusColors["chrono-gray"][500],
        text: statusColors["chrono-gray"][800],
      };
  }
};

/**
 * Badge coloré pour afficher la priorité d'une demande de pièces
 * @param priority - Priorité de la demande
 * @param size - Taille du badge
 * @param className - Classes CSS additionnelles
 * @param iconOnly - Afficher uniquement le point indicateur
 */
export default function ReplenishmentPriorityBadge({ 
  priority,
  size = "sm",
  className = "",
  iconOnly = false
}: ReplenishmentPriorityBadgeProps) {
  const style = getReplenishmentPriorityStyle(priority);

  if (iconOnly) {
    return (
      <Tooltip content={t(`replenishment:priority.${priority}`)}>
        <span 
          className="et-cell-icon-badge" 
          style={{
            backgroundColor: style.soft,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <span 
            className="rounded-full shrink-0" 
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: style.solid,
            }}
          ></span>
        </span>
      </Tooltip>
    );
  }

  return (
    <Chip
      variant="filled"
      size={size}
      value={
        <div className="flex items-center gap-2">
          <span 
            className="rounded-full shrink-0" 
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: style.solid,
            }}
          ></span>
          <span style={{ color: style.text }}>{t(`replenishment:priority.${priority}`)}</span>
        </div>
      }
      style={{ backgroundColor: style.soft }}
      className={`w-fit h-fit rounded-full capitalize font-semibold text-xs py-1 ${className}`}
    />
  );
}